module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/LSearchField.fb5987a6.svg";